import { breakpoints } from '@ecommerce/shared'
import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  @media (${breakpoints.desktop.min}) {
    width: 366px;
  }
`

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (${breakpoints.desktop.min}) {
    gap: 24px;
  }
`

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
`
